type EnumLike = Record<string, string | number>;

export function safeParseEnum<T>(
  enumObject: Record<string, T>,
  value: string | undefined | null,
  defaultValue?: T
): T | undefined {
  if (!value) {
    return undefined;
  }
  const upper = value.toUpperCase();

  if (!Object.keys(enumObject).includes(upper)) {
    return defaultValue;
  }

  return enumObject[upper];
}

export function safeParseEnumArray<T extends EnumLike>(
  enumObj: T,
  raw: string | undefined | null
): T[keyof T][] | undefined {
  if (!raw) return undefined;

  const enumKeys = Object.keys(enumObj);

  const values = raw
    .split(',')
    .map((v) => v.trim().toUpperCase())
    .filter((v) => enumKeys.includes(v));

  return values as T[keyof T][];
}

export function safeParseNumber(value: string | null): number | undefined {
  if (value === null || value.trim() === '') return undefined;

  const num = Number(value);

  return isNaN(num) ? undefined : num;
}
